import React from 'react';

import { Onboarding } from '@confluence/onboarding';
import { Attribution, ErrorBoundary } from '@confluence/error-boundary';

export const OnboardingRoute = () => (
	<ErrorBoundary attribution={Attribution.FLYWHEEL_ACTIVATION}>
		<Onboarding />
	</ErrorBoundary>
);

OnboardingRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'onboardingContainerScreen' },
	},
	MainLayout: false,
});
